import axios from 'axios';
import { HUB_URL_INTEGRATION } from '../config';
import { restoreSettings } from './settings';

const source = axios.CancelToken.source();
const normalizedBaseUrl = HUB_URL_INTEGRATION.replace(/\/+$/, '');

const instance = axios.create({
  baseURL: normalizedBaseUrl,
  cancelToken: source.token,
});

instance.interceptors.request.use(config => {
  const settings = restoreSettings() || {};
  const runtimeBaseUrl =
    settings.hubUrlIntegration ||
    settings.HUB_URL_INTEGRATION ||
    HUB_URL_INTEGRATION ||
    '';

  if (runtimeBaseUrl) {
    config.baseURL = runtimeBaseUrl.replace(/\/+$/, '');
  }

  return config;
});

export default instance;
